"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get deepReplaceStrings () {
        return deepReplaceStrings;
    },
    get getBase64FileSize () {
        return getBase64FileSize;
    },
    get randomTokenString () {
        return randomTokenString;
    },
    get swaggerSanitizeSchemaName () {
        return swaggerSanitizeSchemaName;
    },
    get utf8ify () {
        return utf8ify;
    }
});
const _crypto = /*#__PURE__*/ _interop_require_default(require("crypto"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function randomTokenString() {
    return _crypto.default.randomBytes(40).toString('hex');
}
function utf8ify(str) {
    return Buffer.from(str, 'latin1').toString('utf8');
}
function swaggerSanitizeSchemaName(name) {
    return name.replace(/\W/g, '_');
}
function deepReplaceStrings(value, replacements) {
    if (value === null || value === undefined) return value;
    // Primitive values
    if (typeof value !== 'object') {
        if (typeof value === 'string' && replacements.has(value)) {
            return replacements.get(value);
        }
        return value;
    }
    // Arrays
    if (Array.isArray(value)) {
        return value.map((item)=>deepReplaceStrings(item, replacements));
    }
    // Objects
    const result = {};
    for (const key of Object.keys(value)){
        const val = value[key];
        if (typeof val === 'string' && replacements.has(val)) {
            result[key] = replacements.get(val);
        } else {
            result[key] = deepReplaceStrings(val, replacements);
        }
    }
    return result;
}
function getBase64FileSize(base64String) {
    const len = base64String.length;
    // Count padding at the end
    let padding = 0;
    if (len > 0 && base64String[len - 1] === '=') {
        padding++;
        if (len > 1 && base64String[len - 2] === '=') {
            padding++;
        }
    }
    // Calculate actual file size in bytes
    return len * 3 / 4 - padding;
}
